
import { ref, watch, computed, unref, defineComponent, TransitionGroup } from 'vue'
import { RouteLocationNormalizedLoaded, RouteMeta, useRouter } from 'vue-router'

/* routers */
import 'animate.css'
import { constantRouterMap } from '../../../router/index';

/* Utils */
import { isUrl } from '../../../utils/is';
import { filter, treeToList } from '../../../utils/tree';

export default defineComponent({
    name: 'Breadcrumb',
    setup() {

        const { currentRoute } = useRouter()

        const levelList = ref<AppRouteRecordRaw[]>([])

        /* 解析Url地址 */
        const pathResolve = (parentPath: string, path: string) => {

            if (isUrl(path)) return path

            const childPath = path.startsWith('/') || !path ? path : `/${path}`

            return `${parentPath}${childPath}`.replace(/\/\//g, '/')

        }

        /* 面包屑路由过滤 */
        const filterBreadcrumb = (routes: AppRouteRecordRaw[], parentPath = ""): AppRouteRecordRaw[] => {

            const res: AppRouteRecordRaw[] = []

            for (const route of routes) {

                const meta = route?.meta as RouteMeta

                if (meta.hidden && !meta.canTo) {
                    continue
                }

                const data: AppRouteRecordRaw =
                    !meta.alwaysShow && route.children?.length === 1
                        ? { ...route.children[0], path: pathResolve(route.path, route.children[0].path) }
                        : { ...route }

                data.path = pathResolve(parentPath, data.path)

                if (data.children) {
                    data.children = filterBreadcrumb(data.children, data.path)
                }

                if (data) {
                    res.push(data)
                }

            }

            return res
        }

        /* 获取面包屑 */
        const getBreadcrumb = () => {
            // const routerlist = filterBreadcrumb(constantRouterMap)
            // const currentPath = currentRoute.value.matched.slice(-1)[0].path
            // const treeMapList = filter<AppRouteRecordRaw>(routerlist, (node: AppRouteRecordRaw) => {
            //    return node.path === currentPath
            // })

            // levelList.value = treeToList<AppRouteRecordRaw[]>(treeMapList)
        }

        /* 渲染面包屑项 */
        const renderBreadcrumb = () => {

            const list = unref(levelList);

            return list.map((item) => {

                const disabled = !item.redirect || item.redirect === 'noredirect'
                const meta = item.meta as RouteMeta

                // to={{ path: disabled ? '' : item.path }}
                return (<el-breadcrumb-item key={item.name} >{meta.title}</el-breadcrumb-item>)

            })

        }

        /* 当前路由改变 */
        watch(() => currentRoute.value, (route: RouteLocationNormalizedLoaded) => {

            if (route.path.startsWith('/redirect/'))
                return

            getBreadcrumb()

        }, { immediate: true })

        return () => (
            <el-breadcrumb separator="/">
                <TransitionGroup appear enter-active-class="animate__animated animate__fadeInRight">
                    {/* <el-breadcrumb-item to={{ path: '/home' }}>首页</el-breadcrumb-item> */}
                    {renderBreadcrumb()}
                </TransitionGroup>
            </el-breadcrumb>)
    }
})

